import type { VehicleData, VehicleState } from 'Pages/vehicles/helpers/vehicle.schema';
import type { RealtimeBiddingData } from 'Pages/vehicles/schemas/realtimeBidding.schema';
import { StateName } from 'Types/enquiryStates';
import type { User } from 'Types/user';
import { getVehicleCategoryFromVehicleSlug } from 'Utilities/vehicleState';

import { mapRealtimeBiddingDataToVehicleBiddingData } from './mapRealtimeBiddingDataToVehicleBiddingData';

interface MapRealtimeBiddingDataToVehicleDataParams {
	realtimeBiddingData: RealtimeBiddingData;
	user: User;
	vehicleData: VehicleData;
}

export const mapRealtimeDataToState = (stateSlug: RealtimeBiddingData['stateSlug']): VehicleState => ({
	category: getVehicleCategoryFromVehicleSlug(stateSlug),
	name: StateName[stateSlug],
	slug: stateSlug,
});

export const mapRealtimeBiddingDataToVehicleData = ({
	realtimeBiddingData,
	user,
	vehicleData,
}: MapRealtimeBiddingDataToVehicleDataParams): VehicleData => {
	return {
		...vehicleData,
		bidding: {
			...vehicleData.bidding,
			...mapRealtimeBiddingDataToVehicleBiddingData({ realtimeBiddingData, user }),
		},
		state: {
			...mapRealtimeDataToState(realtimeBiddingData.stateSlug),
		},
	};
};
